export class PermissionsDto {
  static setupResourcePermission(data) {
    if (!data) return null;
    const plans = [...(data.plans ?? [])].sort(
      (a, b) => Number(a.price) - Number(b.price),
    );
    return {
      id: data.id,
      codename: data.codename,
      label: data.label ?? null,
      resourceType: data.resource_type ?? null,
      action: data.action ?? null,
      roles: data.roles ?? {},
      plans,
      cheapestPlan: plans[0] ?? null,
    };
  }

  static setupResourcePermissionList(data) {
    if (!data) return [];
    return data.map(PermissionsDto.setupResourcePermission);
  }
}
